export const fmtINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const fmtMonth = (d) => {
  if (!d) return "—";
  const s = String(d);
  const y = Number(s.slice(0, 4));
  const m = Number(s.slice(5, 7));
  if (!y || !m || m > 12) return "—";
  return new Date(y, m - 1, 1).toLocaleDateString("en-IN", { month: "short", year: "numeric" });
};

export const fmtHour = (t) => {
  if (!t) return "";
  const h = Number(String(t).split(":")[0]);
  if (Number.isNaN(h)) return t;
  return `${h % 12 === 0 ? 12 : h % 12} ${h >= 12 ? "PM" : "AM"}`;
};

export const addMonths = (ym, n) => {
  if (!ym || String(ym).length < 7) return "";
  const y = Number(String(ym).slice(0, 4));
  const m = Number(String(ym).slice(5, 7));
  if (!y || !m || m > 12) return "";
  const t = y * 12 + (m - 1) + n;
  return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`;
};

export const pupAge = (dob) => {
  if (!dob) return null;
  const months = Math.floor((Date.now() - new Date(dob).getTime()) / (1000 * 60 * 60 * 24 * 30.44));
  if (months < 1) return "Under a month";
  if (months < 12) return `${months} mo`;
  const y = Math.floor(months / 12);
  const m = months % 12;
  return m ? `${y} yr ${m} mo` : `${y} yr`;
};

export const STATUS_STYLES = {
  awaiting_payment: "bg-amberwarm/15 text-amberwarm",
  confirmed: "bg-emerald-100 text-emerald-700",
  paid_full: "bg-navy/10 text-navy",
  completed: "bg-slate-100 text-slate-600",
  cancelled: "bg-red-100 text-red-600",
};

export const STATUS_LABELS = {
  awaiting_payment: "Awaiting payment",
  confirmed: "Confirmed",
  paid_full: "Fully paid",
  completed: "Completed",
  cancelled: "Cancelled",
};
